import { MapLayersEnum } from './enums'

export const HOST = `${process.env.REACT_APP_BACKEND_HOST}`

export const POINTS_URL = `${HOST}/v1/points`

export const EVENTS_URL = `${HOST}/v1/events`

export const REVIEW_URL = `${HOST}/v1/reviews`

export const LAYERS_URL = `${HOST}/v1/layers`

export const CATEGORIES_URL = `${HOST}/v1/events/categories`

export const LOCATIONS_URL = `${HOST}/v1/locations`

export const USER_URL = `${HOST}/v1/user`

export const LOGOUT_URL = `${HOST}/logout`

export const OAUTH_EPAM = `${HOST}/oauth2/authorization/epam`

export const MAP_URL = {
  [MapLayersEnum.googleMaps]: {
    url: 'https://www.google.us/maps/vt?lyrs=m@1&language=US&region=US&x={x}&y={y}&z={z}',
    attribution:
      '&copy; <a href="https://www.google.com/intl/en-GB_ALL/permissions/geoguidelines/">Google Maps</a> contributors',
    subdomains: ['mt1', 'mt2', 'mt3'],
  },
  [MapLayersEnum.googleMapsSatellite]: {
    url: 'https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
    attribution:
      '&copy; <a href="https://www.google.com/intl/en-GB_ALL/permissions/geoguidelines/">Google Maps</a> contributors',
    subdomains: ['mt1', 'mt2', 'mt3'],
  },
}

export const GOOGLE_MAPS_URL = `https://www.google.com/maps/search/?api=1`
